import React from 'react';
import { Link } from 'react-router-dom';
import './event_navigation.css';
import proptechLogo from './Proptech Club.png';

const EventNavigation = () => {
    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    return (
        <nav className="event-nav">
            <div className="event-nav-container">
                <div className="event-nav-logo" onClick={() => {window.location.reload()}}>
                    <img src={proptechLogo} alt="PropTech Club Logo" />
                </div>
                <div className="event-nav-links">
                    <button onClick={() => scrollToSection('event_about_section')} className="nav-link">About</button>
                    <button onClick={() => scrollToSection('club_gallery_section')} className="nav-link">Events</button>
                    <Link to="/proptech-club/members">Members</Link>
                </div>
            </div>
        </nav>
    );
};

export default EventNavigation;